var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInteractive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.9967 15.8452C48.9558 15.8452 57.0079 18.9377 62.4306 24.5003C66.8926 25.0806 71.1019 26.9027 74.5786 29.759C68.495 16.9741 55.8934 9.82422 39.9967 9.82422C24.3171 9.82422 11.6287 16.9645 5.47266 29.7108C8.66036 27.109 12.463 25.3697 16.5159 24.6595C21.8373 18.8557 30.2223 15.8452 39.9967 15.8452Z",
    fill: "#404041"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2974 63.968L59.293 63.968C55.2595 63.9727 51.3836 62.4039 48.489 59.5957L48.311 59.4177L48.0993 59.2586C47.483 58.7956 46.8218 58.3955 46.1257 58.0644L46.1098 58.0569L46.094 58.0495C44.1787 57.1605 42.0892 56.7102 39.978 56.7313C37.3541 56.7348 35.2951 57.3909 33.8813 58.0629C33.1838 58.3932 32.5212 58.7928 31.9035 59.2556L31.6897 59.4158L31.5117 59.5938C29.6876 61.3588 27.4589 62.6504 25.0204 63.3558C22.5735 64.0635 19.9902 64.1593 17.4977 63.6346C15.0051 63.1099 12.6796 61.9809 10.7257 60.3468C8.7718 58.7126 7.24928 56.6235 6.29204 54.263C5.33479 51.9026 4.97214 49.3431 5.23598 46.8096C5.49981 44.2761 6.38204 41.8463 7.8051 39.7337C9.22816 37.6211 11.1485 35.8905 13.3972 34.694C15.6458 33.4976 18.154 32.8719 20.7012 32.8721H20.7014H59.2974C63.4209 32.8721 67.3756 34.5102 70.2914 37.426C73.2072 40.3418 74.8453 44.2965 74.8453 48.42C74.8453 52.5436 73.2072 56.4983 70.2914 59.4141C67.3756 62.3299 63.4209 63.968 59.2974 63.968Z",
    stroke: "#404041",
    strokeWidth: 7.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInteractive);
export default __webpack_public_path__ + "static/media/interactive.4d50e880a9ab881dc4bf9efd3197b4ca.svg";
export { ForwardRef as ReactComponent };